import React, { Component, PropTypes } from 'react';

export default class NumberField extends Component {
    static propTypes = {
        val: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        help: PropTypes.string.isRequired
    };

    state = {
        val : '',
        showHelp: 'none'
    };

    handleChange = (e) => {
        this.setState({val : e.target.value, showHelp: 'inline'});

        this.props.onChange(e);
    };

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            val: nextProps.val
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    render() {
        var className = this.state.val ? 'form-control edited' : 'form-control';

        return (
            <div className="form-group form-md-line-input">
                <input type="number" className={className} id={this.props.id}
                       onFocus={(e) => this.setState({showHelp: 'inline'})}
                       onBlur={(e) => this.setState({showHelp: 'none '})}
                       name={this.props.id} onChange={this.handleChange}
                       value={this.state.val} />

                <label htmlFor={this.props.id}>{this.props.label}</label>
                <span className="help-block" style={{ display: this.state.showHelp }}>{this.props.help}</span>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/NumberField.js
 **/